import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router/dom";

import "./index.css";

import { router } from "./App";
import { CircuitBreakerProvider } from "circuitbreaker/CircuitBreaker";
import { DirtyStateManagerProvider } from "utility/DirtyStateManager";
import { NotificationManagerProvider } from "notifications/NotificationManager";
import { MCPAuthProvider } from "./mcp/hooks/useMCPAuth.tsx";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");

const root = ReactDOM.createRoot(rootElement);

root.render(
    // <React.StrictMode> // It's good practice to re-enable this
    <NotificationManagerProvider>
        <CircuitBreakerProvider>
            <DirtyStateManagerProvider>
                <MCPAuthProvider>
                    <RouterProvider router={router} />
                </MCPAuthProvider>
            </DirtyStateManagerProvider>
        </CircuitBreakerProvider>
    </NotificationManagerProvider>
    // </React.StrictMode>
);